﻿//src/desktop/ui/diagrams/unitstatusesdiagrams.js

import global from '../../../../../shared/utils/global.js';
import { getWheelProperties } from '../unitdiagrams/sensors/handlesensordata.js';
import { formatZuluTime } from '../../../../../shared/utils/timeformats.js';

function getSelectedMetrics() {
  const metrics = [];

  if (document.getElementById('rbtnPressure')?.checked) {
    metrics.push('PRESSURE');
  }

  if (document.getElementById('rbtnTemperature')?.checked) {
    metrics.push('TEMPERATURE');
  }

  if (document.getElementById('rbtnVoltage')?.checked) {
    metrics.push('VOLTAGE');
  }

  return metrics.length ? metrics : ['PRESSURE'];
}

function displaySelectedMetricRows(unitStatusDiagramDiv, unit) {
  unitStatusDiagramDiv.textContent = '';
  unitStatusDiagramDiv.className = 'statusdiagram-stack';

  const selectedMetrics = getSelectedMetrics();

  selectedMetrics.forEach(metric => {
    const row = document.createElement('div');
    row.className = 'statusdiagram-row';

    const label = document.createElement('div');
    label.className = 'metric-row-label';
    label.innerText =
      metric === 'PRESSURE' ? 'P' :
        metric === 'TEMPERATURE' ? 'T' :
          'V';

    row.appendChild(label);

    switch (metric) {
      case 'PRESSURE':
        displayUnitPressureStatus(row, unit);
        break;
      case 'TEMPERATURE':
        displayUnitTemperatureStatus(row, unit);
        break;
      case 'VOLTAGE':
        displayUnitVoltageStatus(row, unit);
        break;
    }

    unitStatusDiagramDiv.appendChild(row);
  });
}

// function displaySelectedMetricRows(unitStatusDiagramDiv, unit) {
//   unitStatusDiagramDiv.textContent = '';
//   unitStatusDiagramDiv.className = 'statusdiagram-stack';

//   const selectedMetrics = getSelectedMetrics();

//   selectedMetrics.forEach(metric => {
//     const row = document.createElement('div');
//     row.className = 'statusdiagram-row';

//     const icon = document.createElement('img');
//     icon.className = 'metric-row-icon';
//     icon.alt = metric;

//     icon.src =
//       metric === 'PRESSURE'
//         ? 'styles/icons/pressure.svg'
//         : metric === 'TEMPERATURE'
//           ? 'styles/icons/temperature.svg'
//           : 'styles/icons/voltage.svg';

//     row.appendChild(icon);

//     switch (metric) {
//       case 'PRESSURE':
//         displayUnitPressureStatus(row, unit);
//         break;

//       case 'TEMPERATURE':
//         displayUnitTemperatureStatus(row, unit);
//         break;

//       case 'VOLTAGE':
//         displayUnitVoltageStatus(row, unit);
//         break;
//     }

//     unitStatusDiagramDiv.appendChild(row);
//   });
// }

export const displayStatusSummary = (units) => {
  const safePercent = (value, total) => {
    if (!total || total <= 0) return '- ';
    return Math.round((value / total) * 100);
  };

  const setText = (id, value) => {
    const el = document.getElementById(id);
    if (el) el.innerText = value;
  };

  const setDisplay = (id, show) => {
    const el = document.getElementById(id);
    if (el) el.style.display = show ? 'inherit' : 'none';
  };

  const selectedMetrics = getSelectedMetrics();

  const showPressure = selectedMetrics.includes('PRESSURE');
  const showTemperature = selectedMetrics.includes('TEMPERATURE');
  const showVoltage = selectedMetrics.includes('VOLTAGE');

  // Hide the old separate "Correct X:" labels.
  // We now write the full text into the single #normal span.
  setDisplay('normalpressurelabel', false);
  setDisplay('normaltemperaturelabel', false);
  setDisplay('normalvoltagelabel', false);

  const unitTotal = units?.length || 0;
  setText('totalunits', unitTotal || '-');

  let totalSensorValues = 0;
  let yellowStatus = 0;
  let redStatus = 0;
  let purpleStatus = 0;
  let orangeStatus = 0;
  let grayStatus = 0;

  if (unitTotal > 0) {
    units.forEach(unit => {
      const wheelSensors = unit.wheelSensors || [];
      const spareSensors = unit.spareSensors || [];
      const unpairedSensors = unit.unpairedSensors || [];

      totalSensorValues += wheelSensors.length + spareSensors.length + unpairedSensors.length;

      yellowStatus += parseInt(unit.yellowFlags || 0);
      redStatus += parseInt(unit.redFlags || 0);
      purpleStatus += parseInt(unit.purpleFlags || 0);
      orangeStatus += parseInt(unit.orangeFlags || 0);
      grayStatus += parseInt(unit.grayFlags || 0);
    });
  }

  const correctPressure = totalSensorValues - (redStatus + purpleStatus + grayStatus);
  const correctTemperature = totalSensorValues - (orangeStatus + grayStatus);
  const correctVoltage = totalSensorValues - (yellowStatus + grayStatus);

  setText('totalSensorValues', totalSensorValues || '-');

  setDisplay('underinflatedmetrics', showPressure);
  setDisplay('overinflatedmetrics', showPressure);
  setDisplay('hightemperaturemetrics', showTemperature);
  setDisplay('lowvoltagemetrics', showVoltage);

  setText('underInflated', unitTotal ? redStatus : '-');
  setText('percentageUnderInflated', unitTotal ? safePercent(redStatus, totalSensorValues) : '- ');

  setText('overInflated', unitTotal ? purpleStatus : '-');
  setText('percentageOverInflated', unitTotal ? safePercent(purpleStatus, totalSensorValues) : '- ');

  setText('hightemperature', unitTotal ? orangeStatus : '-');
  setText('percentagehightemperature', unitTotal ? safePercent(orangeStatus, totalSensorValues) : '- ');

  setText('lowvoltage', unitTotal ? yellowStatus : '-');
  setText('percentagelowvoltage', unitTotal ? safePercent(yellowStatus, totalSensorValues) : '- ');

  setText('noSignal', unitTotal ? grayStatus : '-');

  const normalParts = [];

  if (showPressure) {
    normalParts.push(`Correct Pressure: ${unitTotal ? correctPressure : '-'}`);
  }

  if (showTemperature) {
    normalParts.push(`Correct Temperature: ${unitTotal ? correctTemperature : '-'}`);
  }

  if (showVoltage) {
    normalParts.push(`Correct Voltage: ${unitTotal ? correctVoltage : '-'}`);
  }

  setText('normal', normalParts.length ? normalParts.join(' | ') : '-');

  let normalPercentage = '- ';

  // if (unitTotal) {
  //   if (showPressure) {
  //     normalPercentage = safePercent(correctPressure, totalSensorValues);
  //   } else if (showTemperature) {
  //     normalPercentage = safePercent(correctTemperature, totalSensorValues);
  //   } else if (showVoltage) {
  //     normalPercentage = safePercent(correctVoltage, totalSensorValues);
  //   }
  // }

  // setText('percentagenormal', normalPercentage);

  const normalPercentageBlock = document.getElementById('percentagenormal')?.closest('.metricsummaryperc');

  if (normalPercentageBlock) {
    normalPercentageBlock.style.display = 'none';
  }

  const lastUpdatedMain = document.getElementById('lastupdatedmain');
  if (lastUpdatedMain) {
    lastUpdatedMain.innerText = formatZuluTime(new Date());
  }
};

// export const displayStatusSummary = (units) => {

//   let unitTotal = units.length;
//   const totalUnitsSpan = document.getElementById('totalunits');
//   totalUnitsSpan.style.display = 'block';
//   if (parseInt(unitTotal) === 0) {

//     totalUnitsSpan.innerText = '-';

//     document.getElementById('lowvoltagemetrics').style.display = 'none';
//     document.getElementById('underinflatedmetrics').style.display = 'inherit';
//     document.getElementById('overinflatedmetrics').style.display = 'inherit';
//     document.getElementById('hightemperaturemetrics').style.display = 'none';

//     const underInflatedSpan = document.getElementById('underInflated');
//     underInflatedSpan.innerText = '-';
//     const percUnderInflatedSpan = document.getElementById('percentageUnderInflated');
//     percUnderInflatedSpan.innerText = '- ';
//     const overInflatedSpan = document.getElementById('overInflated');
//     overInflatedSpan.innerText = '-';
//     const percOverInflatedSpan = document.getElementById('percentageOverInflated');
//     percOverInflatedSpan.innerText = '- ';
//     document.getElementById('normalvoltagelabel').style.display = 'none';
//     document.getElementById('normalpressurelabel').style.display = 'inherit';
//     document.getElementById('normaltemperaturelabel').style.display = 'none';
//     const normalSpan = document.getElementById('normal');
//     normalSpan.innerText = '-';
//     const percNormalSpan = document.getElementById('percentagenormal');
//     percNormalSpan.innerText = '- ';

//     const noSignalSpan = document.getElementById('noSignal');
//     noSignalSpan.innerText = '-';
//     //const percNoSignalSpan = document.getElementById('percentagenosignal');
//     //percNoSignalSpan.innerText = '- ';
//     const totalSensorValuesSpan = document.getElementById('totalSensorValues');
//     totalSensorValuesSpan.innerText = '-';
//   } else {

//     totalUnitsSpan.innerText = unitTotal;

//     let totalSensorValues = 0;
//     let yellowStatus = 0;
//     let blinkStatus = 0;
//     let redStatus = 0;
//     let greenStatus = 0;
//     let purpleStatus = 0;
//     let orangeStatus = 0;
//     let grayStatus = 0;

//     for (let unit = 0; unit < units.length; unit++) {

//       const unpaired = units[unit].unpairedSensors || [];
//       totalSensorValues = parseInt(totalSensorValues) + parseInt(units[unit].wheelSensors.length) + parseInt(units[unit].spareSensors.length) + parseInt(unpaired.length);
//       //totalSensorValues = parseInt(totalSensorValues) + parseInt(units[unit].wheelSensors.length) + parseInt(units[unit].spareSensors.length);
//       yellowStatus = parseInt(yellowStatus) + parseInt(units[unit].yellowFlags);
//       blinkStatus = parseInt(blinkStatus) + parseInt(units[unit].blinkFlags);
//       redStatus = parseInt(redStatus) + parseInt(units[unit].redFlags);
//       purpleStatus = parseInt(purpleStatus) + parseInt(units[unit].purpleFlags);
//       orangeStatus = parseInt(orangeStatus) + parseInt(units[unit].orangeFlags);
//       grayStatus = parseInt(grayStatus) + parseInt(units[unit]?.grayFlags || 0);
//     }

//     if (document.getElementById('rbtnPressure').checked === true) {

//       global.selectedMetric = "PRESSURE";

//       document.getElementById('lowvoltagemetrics').style.display = 'none';
//       document.getElementById('underinflatedmetrics').style.display = 'inherit';
//       document.getElementById('overinflatedmetrics').style.display = 'inherit';
//       document.getElementById('hightemperaturemetrics').style.display = 'none';

//       let underInflatedSpan = document.getElementById('underInflated');
//       underInflatedSpan.innerText = redStatus;
//       let percUnderInflatedSpan = document.getElementById('percentageUnderInflated');
//       percUnderInflatedSpan.innerText = Math.round(redStatus / totalSensorValues * 100);
//       let overInflatedSpan = document.getElementById('overInflated');
//       overInflatedSpan.innerText = purpleStatus;
//       let percOverInflatedSpan = document.getElementById('percentageOverInflated');
//       percOverInflatedSpan.innerText = Math.round(purpleStatus / totalSensorValues * 100);
//       document.getElementById('normalvoltagelabel').style.display = 'none';
//       document.getElementById('normalpressurelabel').style.display = 'inherit';
//       document.getElementById('normaltemperaturelabel').style.display = 'none';
//       let normalSpan = document.getElementById('normal');
//       greenStatus = totalSensorValues - (redStatus + purpleStatus + grayStatus);
//       normalSpan.innerText = greenStatus;
//       let percNormalSpan = document.getElementById('percentagenormal');
//       percNormalSpan.innerText = Math.round(greenStatus / totalSensorValues * 100);
//     }

//     if (document.getElementById('rbtnTemperature').checked === true) {

//       global.selectedMetric = "TEMPERATURE";

//       document.getElementById('lowvoltagemetrics').style.display = 'none';
//       document.getElementById('underinflatedmetrics').style.display = 'none';
//       document.getElementById('overinflatedmetrics').style.display = 'none';
//       document.getElementById('hightemperaturemetrics').style.display = 'inherit';

//       document.getElementById('normalvoltagelabel').style.display = 'none';
//       document.getElementById('normalpressurelabel').style.display = 'none';
//       document.getElementById('normaltemperaturelabel').style.display = 'inherit';
//       let normalSpan = document.getElementById('normal');
//       greenStatus = parseInt(greenStatus) + (parseInt(totalSensorValues) - parseInt((parseInt(orangeStatus) + parseInt(grayStatus))));
//       normalSpan.innerText = greenStatus;
//       let percNormalSpan = document.getElementById('percentagenormal');
//       percNormalSpan.innerText = Math.round(greenStatus / totalSensorValues * 100);
//       let highTemperatureSpan = document.getElementById('hightemperature');
//       highTemperatureSpan.innerText = orangeStatus;
//       let percentageHighTemperatureSpan = document.getElementById('percentagehightemperature');
//       percentageHighTemperatureSpan.innerText = Math.round(orangeStatus / totalSensorValues * 100);
//     }

//     if (document.getElementById('rbtnVoltage').checked === true) {

//       global.selectedMetric = "VOLTAGE";

//       document.getElementById('lowvoltagemetrics').style.display = 'inherit';
//       document.getElementById('underinflatedmetrics').style.display = 'none';
//       document.getElementById('overinflatedmetrics').style.display = 'none';
//       document.getElementById('hightemperaturemetrics').style.display = 'none';

//       let lowVoltageSpan = document.getElementById('lowvoltage');
//       lowVoltageSpan.innerText = yellowStatus;
//       let percentageLowVoltageSpan = document.getElementById('percentagelowvoltage');
//       percentageLowVoltageSpan.innerText = Math.round(yellowStatus / totalSensorValues * 100);
//       document.getElementById('normalvoltagelabel').style.display = 'inherit';
//       document.getElementById('normalpressurelabel').style.display = 'none';
//       document.getElementById('normaltemperaturelabel').style.display = 'none';
//       let normalSpan = document.getElementById('normal');
//       greenStatus = parseInt(greenStatus) + (parseInt(totalSensorValues) - parseInt((parseInt(yellowStatus) + parseInt(grayStatus))));
//       normalSpan.innerText = greenStatus;
//       let percNormalSpan = document.getElementById('percentagenormal');
//       percNormalSpan.innerText = Math.round(greenStatus / totalSensorValues * 100);
//     }

//     const noSignalSpan = document.getElementById('noSignal');
//     noSignalSpan.innerText = grayStatus;
//     //const percNoSignalSpan = document.getElementById('percentagenosignal');
//     //percNoSignalSpan.innerText = Math.round(grayStatus / totalSensorValues * 100);
//     const totalSensorValuesSpan = document.getElementById('totalSensorValues');
//     totalSensorValuesSpan.innerText = totalSensorValues;
//   }

//   const lastUpdatedMain = document.getElementById('lastupdatedmain');
//   const now = new Date();
//   lastUpdatedMain.innerText = formatZuluTime(now);
// };

export function createSubunitContainers(unit) {

  const subunitFragment = document.createDocumentFragment();

  const sensors = [...unit.wheelSensors, ...unit.spareSensors];

  const subunitSensorsMap = {};

  sensors.forEach(sensor => {
    const lastDigit = sensor.wheelId.slice(-1);

    if (!subunitSensorsMap[lastDigit]) {
      subunitSensorsMap[lastDigit] = [];
    }
    subunitSensorsMap[lastDigit].push(sensor);
  });

  const subunitKeys = Object.keys(subunitSensorsMap).sort((a, b) => a - b);

  const subunitMap = {};

  subunitKeys.forEach(lastDigit => {
    // Sort the sensors within each subunit by pressure, temperature, or voltage
    subunitSensorsMap[lastDigit].sort((s1, s2) => {
      if (global.selectedMetric === 'TEMPERATURE') {
        return parseFloat(s2.currentTemperature) - parseFloat(s1.currentTemperature); // Descending for temperature
      } else {
        return parseFloat(s1.currentPressure) - parseFloat(s2.currentPressure); // Ascending for pressure and voltage
      }
    });

    // Create the subunit container if it doesn't exist
    if (!subunitMap[lastDigit]) {
      const subunitDiv = document.createElement('div');
      subunitDiv.id = `u${unit.imei}sub${lastDigit}`;
      subunitDiv.className = 'statusdiagram-stack subunit';

      // Add subunit name as a header element
      const subunitNameDiv = document.createElement('div');
      subunitNameDiv.className = 'subunitname';

      // Set the name based on lastDigit
      if (lastDigit === '0') {
        subunitNameDiv.innerText = unit.name || unit.imei; // Main unit
      } else {
        subunitNameDiv.innerText = unit.trailers.find(trailer => trailer.trailerNumber === parseInt(lastDigit)).name || `Trailer ${lastDigit}`;
      }

      // Append the name div to the subunit div
      //subunitDiv.appendChild(subunitNameDiv);
      subunitMap[lastDigit] = subunitDiv;
      subunitFragment.appendChild(subunitNameDiv);
      subunitFragment.appendChild(subunitDiv);
    }

    // Create subunit container if it doesn't exist
    if (!subunitMap[lastDigit]) {
      const subunitDiv = document.createElement('div');
      subunitDiv.id = `unit${unit.imei}sub${lastDigit}`;
      subunitDiv.className = 'statusdiagram-stack subunit';
      const subunitNameDiv = document.createElement('div');
      subunitNameDiv.className = 'subunitname';
      if (lastDigit === '0') {
        subunitNameDiv.innerText = unit.name || unit.imei; // Main unit
      } else {
        subunitNameDiv.innerText = sensor.repeater?.trailerName || `Trailer ${lastDigit}`; // Subunit name
      }

      subunitMap[lastDigit] = subunitDiv;
      subunitFragment.appendChild(subunitNameDiv);
      subunitFragment.appendChild(subunitDiv);
    }

    // Add sensor status to the subunit container
    let sensorDiv;
    let noSignalDivs = [];  // Array to hold 'no signal' divs

    // First, append sensors with a signal
    const selectedMetrics = getSelectedMetrics();

    selectedMetrics.forEach(metric => {
      const metricRow = document.createElement('div');
      metricRow.className = 'statusdiagram-row';

      const label = document.createElement('div');
      label.className = 'metric-row-label';
      label.innerText =
        metric === 'PRESSURE' ? 'P' :
          metric === 'TEMPERATURE' ? 'T' :
            'V';

      metricRow.appendChild(label);

      const noSignalDivs = [];

      subunitSensorsMap[lastDigit].forEach(sensor => {
        const sensorDiv = createSensorDivByMetric(unit, sensor, metric);
        if (!sensorDiv) return;

        if (sensor.signal) {
          metricRow.appendChild(sensorDiv);
        } else {
          noSignalDivs.push(sensorDiv);
        }
      });

      noSignalDivs.forEach(div => metricRow.appendChild(div));

      subunitMap[lastDigit].appendChild(metricRow);
    });

  });

  const rawUnpaired = unit.unpairedSensors || [];

  if (Array.isArray(rawUnpaired) && rawUnpaired.length > 0) {

    // Sort using the same metric logic
    const unpairedSensors = sortSensors([...rawUnpaired]);

    const unpairedNameDiv = document.createElement('div');
    unpairedNameDiv.className = 'subunitname';
    unpairedNameDiv.innerText = 'Unpaired sensors';

    const unpairedDiv = document.createElement('div');
    unpairedDiv.id = `u${unit.imei}sub-unpaired`;
    unpairedDiv.className = 'statusdiagram subunit';

    //const noSignalDivs = [];

    unpairedSensors.forEach(sensor => {
      const sensorDiv = createUnpairedSensorDivByMetric(unit, sensor);
      if (!sensorDiv) return;
      unpairedDiv.appendChild(sensorDiv);
      // if (sensor.signal) {
      //     unpairedDiv.appendChild(sensorDiv);
      // } else {
      //     noSignalDivs.push(sensorDiv);
      // }
    });

    // no-signal at the end, just like other rows
    // noSignalDivs.forEach(div => unpairedDiv.appendChild(div));

    subunitFragment.appendChild(unpairedNameDiv);
    subunitFragment.appendChild(unpairedDiv);
  }

  return subunitFragment;
}

function sortSensors(sensors) {

  const metric = global.selectedMetric;
  return sensors.sort((s1, s2) => {
    switch (metric) {
      case 'PRESSURE':
        return parseFloat(s1.currentPressure) - parseFloat(s2.currentPressure);
      case 'TEMPERATURE':
        return parseFloat(s2.currentTemperature) - parseFloat(s1.currentTemperature);
      case 'VOLTAGE':
        return parseFloat(s1.currentVoltage) - parseFloat(s2.currentVoltage);
      default:
        return 0;
    }
  });
}

function createSensorDivByMetric(unit, sensor, metric = global.selectedMetric) {
  switch (metric) {
    case 'PRESSURE':
      return sensor.signal
        ? createSensorPressureElement(unit.imei, sensor)
        : createSensorNoSignalElement(unit.imei, sensor, 'pressure');

    case 'TEMPERATURE':
      return sensor.signal
        ? createSensorTemperatureElement(unit.imei, sensor)
        : createSensorNoSignalElement(unit.imei, sensor, 'temperature');

    case 'VOLTAGE':
      return sensor.signal
        ? createSensorVoltageElement(unit.imei, sensor)
        : createSensorNoSignalElement(unit.imei, sensor, 'voltage');

    default:
      return null;
  }
}

function createUnpairedSensorDivByMetric(unit, sensor) {
  const metric = global.selectedMetric;
  switch (metric) {
    case 'PRESSURE':
      return createUnpairedSensorPressureElement(unit.imei, sensor);
    case 'TEMPERATURE':
      return createUnpairedSensorTemperatureElement(unit.imei, sensor);
    case 'VOLTAGE':
      return createUnpairedSensorVoltageElement(unit.imei, sensor);
      return null;
  }
}


export function splitSubunits(unitStatusDiv, unit) {
  // Clear the current content
  unitStatusDiv.textContent = '';

  // Separate sensors into main unit and trailers based on wheelId's last digit
  const mainSensors = unit.wheelSensors.filter(sensor => sensor.wheelId.endsWith('0'));
  const trailerSensors = unit.wheelSensors.filter(sensor => !sensor.wheelId.endsWith('0'));

  // Create main unit status
  const mainUnitDiv = document.createElement('div');
  mainUnitDiv.className = 'statusdiagram';
  mainUnitDiv.innerHTML = '<b>Main Unit</b>';
  displayUnitPressureStatusExpanded(mainUnitDiv, unit, mainSensors);
  mainSensors.forEach(sensor => {
    const sensorDiv = createSensorPressureElement(unit.imei, sensor);
    mainUnitDiv.appendChild(sensorDiv);
  });
  unitStatusDiv.appendChild(mainUnitDiv);

  // Create trailer statuses ordered by last digit of wheelId
  let trailers = getTrailers(trailerSensors);

  for (let trailer in trailers) {
    const trailerDiv = document.createElement('div');
    trailerDiv.className = 'trailer-container statusdiagram';
    trailerDiv.innerHTML = `<b>Trailer ${trailer}</b>`;
    displayUnitPressureStatusExpanded(trailerDiv, unit, trailers[trailer]);
    //trailers[trailer].forEach(sensor => {
    //    const sensorDiv = createSensorPressureElement(unit.imei, sensor);
    //    trailerDiv.appendChild(sensorDiv);
    //});
    unitStatusDiv.appendChild(trailerDiv);
  }
}

function getTrailers(sensors) {
  let trailers = {};

  sensors.forEach(sensor => {
    let trailerNo = sensor.wheelId.slice(-1);  // Get the last digit
    if (!trailers[trailerNo]) {
      trailers[trailerNo] = [];
    }
    trailers[trailerNo].push(sensor);
  });

  return trailers;
}

export function loadUnitStatusDiagram(unit) {

  unit.wheelSensors = getWheelProperties(unit.wheelSensors);
  unit.spareSensors = getWheelProperties(unit.spareSensors);
  unit.unpairedSensors = getWheelProperties(unit.unpairedSensors || []);

  let unitStatusDiagramDiv = document.getElementById(`unitstatusdiagram${unit.unitId}`);
  if (unitStatusDiagramDiv != null) {
    while (unitStatusDiagramDiv.hasChildNodes()) {
      unitStatusDiagramDiv.removeChild(unitStatusDiagramDiv.lastChild);
    }
  } else {
    unitStatusDiagramDiv = document.createElement('div');
  }
  unitStatusDiagramDiv.id = `unitstatusdiagram${unit.unitId}`;
  unitStatusDiagramDiv.className = 'statusdiagram';

  displaySelectedMetricRows(unitStatusDiagramDiv, unit);

  // switch (global.selectedMetric) {
  //   case 'PRESSURE':
  //     displayUnitPressureStatus(unitStatusDiagramDiv, unit);
  //     break;
  //   case 'TEMPERATURE':
  //     displayUnitTemperatureStatus(unitStatusDiagramDiv, unit);
  //     break;
  //   case 'VOLTAGE':
  //     displayUnitVoltageStatus(unitStatusDiagramDiv, unit);
  //     break;
  //   default:
  // }

  // const metricStatusOptions = document.querySelectorAll('input[name="optmetricstatus"]');
  //   for (const metricStatusOption of metricStatusOptions) {
  //   metricStatusOption.addEventListener('change', () => {

  //     if (unitStatusDiagramDiv != null) {
  //       while (unitStatusDiagramDiv.hasChildNodes()) {
  //         unitStatusDiagramDiv.removeChild(unitStatusDiagramDiv.lastChild);
  //       }
  //     }
  //     switch (metricStatusOption.value) {
  //       case "Pressure":
  //         global.selectedMetric = 'PRESSURE';
  //         displayUnitPressureStatus(unitStatusDiagramDiv, unit);
  //         break;
  //       case "Temperature":
  //         global.selectedMetric = 'TEMPERATURE';
  //         displayUnitTemperatureStatus(unitStatusDiagramDiv, unit);
  //         break;
  //       case "Voltage":
  //         global.selectedMetric = 'VOLTAGE';
  //         displayUnitVoltageStatus(unitStatusDiagramDiv, unit);
  //         break;
  //       default:
  //     }
  //   });
  // }

  // const metricStatusOptions = document.querySelectorAll('.metric-status-check');

  // metricStatusOptions.forEach(metricStatusOption => {
  //   metricStatusOption.addEventListener('change', () => {
  //     displaySelectedMetricRows(unitStatusDiagramDiv, unit);
  //   });
  // });



  return unitStatusDiagramDiv;
}

export function loadUnitOnlyStatusDiagram(unit) {

  unit.wheelSensors = getWheelProperties(unit.wheelSensors);
  unit.spareSensors = getWheelProperties(unit.spareSensors);
  unit.unpairedSensors = getWheelProperties(unit.unpairedSensors || []);

  let unitStatusDiagramDiv = document.getElementById(`unitonlystatusdiagram${unit.imei}`);
  if (unitStatusDiagramDiv != null) {
    while (unitStatusDiagramDiv.hasChildNodes()) {
      unitStatusDiagramDiv.removeChild(unitStatusDiagramDiv.lastChild);
    }
  } else {
    unitStatusDiagramDiv = document.createElement('div');
  }
  unitStatusDiagramDiv.id = `unitonlystatusdiagram${unit.imei}`;
  unitStatusDiagramDiv.className = 'statusdiagram';

  displaySelectedMetricRows(unitStatusDiagramDiv, unit);

  // switch (global.selectedMetric) {
  //   case 'PRESSURE':
  //     displayUnitPressureStatus(unitStatusDiagramDiv, unit);
  //     break;
  //   case 'TEMPERATURE':
  //     displayUnitTemperatureStatus(unitStatusDiagramDiv, unit);
  //     break;
  //   case 'VOLTAGE':
  //     displayUnitVoltageStatus(unitStatusDiagramDiv, unit);
  //     break;
  //   default:
  //}

  // const metricStatusOptions = document.querySelectorAll('input[name="optmetricstatus"]');
  // for (const metricStatusOption of metricStatusOptions) {
  //   metricStatusOption.addEventListener('change', () => {
  //     if (unitStatusDiagramDiv != null) {
  //       while (unitStatusDiagramDiv.hasChildNodes()) {
  //         unitStatusDiagramDiv.removeChild(unitStatusDiagramDiv.lastChild);
  //       }
  //     }
  //     switch (metricStatusOption.value) {
  //       case "Pressure":
  //         global.selectedMetric = 'PRESSURE';
  //         displayUnitPressureStatus(unitStatusDiagramDiv, unit);
  //         break;
  //       case "Temperature":
  //         global.selectedMetric = 'TEMPERATURE';
  //         displayUnitTemperatureStatus(unitStatusDiagramDiv, unit);
  //         break;
  //       case "Voltage":
  //         global.selectedMetric = 'VOLTAGE';
  //         displayUnitVoltageStatus(unitStatusDiagramDiv, unit);
  //         break;
  //       default:
  //     }
  //   });
  // }

  // const metricStatusOptions = document.querySelectorAll('.metric-status-check');

  // metricStatusOptions.forEach(metricStatusOption => {
  //   metricStatusOption.addEventListener('change', () => {
  //     displaySelectedMetricRows(unitStatusDiagramDiv, unit);
  //   });
  // });

  return unitStatusDiagramDiv;
}

export function loadTrailerStatusDiagram(trailer) {

  trailer.wheelSensors = getWheelProperties(trailer.wheelSensors);
  trailer.spareSensors = getWheelProperties(trailer.spareSensors);

  let unitStatusDiagramDiv = document.getElementById(`trailerstatusdiagram${trailer.Id}`);
  if (unitStatusDiagramDiv != null) {
    while (unitStatusDiagramDiv.hasChildNodes()) {
      unitStatusDiagramDiv.removeChild(unitStatusDiagramDiv.lastChild);
    }
  } else {
    unitStatusDiagramDiv = document.createElement('div');
  }
  unitStatusDiagramDiv.id = `trailerstatusdiagram${trailer.Id}`;
  unitStatusDiagramDiv.className = 'statusdiagram';

  displaySelectedMetricRows(unitStatusDiagramDiv, trailer);

  // switch (global.selectedMetric) {
  //   case 'PRESSURE':
  //     displayUnitPressureStatus(unitStatusDiagramDiv, trailer);
  //     break;
  //   case 'TEMPERATURE':
  //     displayUnitTemperatureStatus(unitStatusDiagramDiv, trailer);
  //     break;
  //   case 'VOLTAGE':
  //     displayUnitVoltageStatus(unitStatusDiagramDiv, trailer);
  //     break;
  //   default:
  //}

  // const metricStatusOptions = document.querySelectorAll('input[name="optmetricstatus"]');
  // for (const metricStatusOption of metricStatusOptions) {
  //   metricStatusOption.addEventListener('change', () => {

  //     if (unitStatusDiagramDiv != null) {
  //       while (unitStatusDiagramDiv.hasChildNodes()) {
  //         unitStatusDiagramDiv.removeChild(unitStatusDiagramDiv.lastChild);
  //       }
  //     }
  //     switch (metricStatusOption.value) {
  //       case "Pressure":
  //         global.selectedMetric = 'PRESSURE';
  //         displayUnitPressureStatus(unitStatusDiagramDiv, trailer);
  //         break;
  //       case "Temperature":
  //         global.selectedMetric = 'TEMPERATURE';
  //         displayUnitTemperatureStatus(unitStatusDiagramDiv, trailer);
  //         break;
  //       case "Voltage":
  //         global.selectedMetric = 'VOLTAGE';
  //         displayUnitVoltageStatus(unitStatusDiagramDiv, trailer);
  //         break;
  //       default:
  //     }
  //   });
  // }

  // const metricStatusOptions = document.querySelectorAll('.metric-status-check');

  // metricStatusOptions.forEach(metricStatusOption => {
  //   metricStatusOption.addEventListener('change', () => {
  //     displaySelectedMetricRows(unitStatusDiagramDiv, trailer);
  //   });
  // });

  return unitStatusDiagramDiv;
}

function displayUnitPressureStatus(unitStatusDiagramDiv, unit) {

  const sensors = [
    ...unit.wheelSensors,
    ...(unit.spareSensors ? unit.spareSensors : []),
    ...(unit.unpairedSensors ? unit.unpairedSensors : [])
  ];

  sensors.sort(function (s1, s2) {
    if (parseFloat(s1.currentPressure) > parseFloat(s2.currentPressure)) return 1;
    if (parseFloat(s1.currentPressure) < parseFloat(s2.currentPressure)) return -1;
    return 0;
  });

  for (let s = 0; s < sensors.length; s++) {
    if (sensors[s].signal) {
      let sensorStatusDiv = createSensorPressureElement(unit.imei, sensors[s]);
      if (sensors[s]?.unpaired) {
        sensorStatusDiv = createUnpairedSensorPressureElement(unit.imei, sensors[s]);
      }
      unitStatusDiagramDiv.appendChild(sensorStatusDiv);
    }
  }

  for (let s = 0; s < sensors.length; s++) {
    if (!sensors[s].signal) {
      let sensorNoSignalDiv = createSensorNoSignalElement(unit.imei, sensors[s], 'pressure');
      if (sensors[s]?.unpaired) {
        sensorNoSignalDiv = createUnpairedSensorNoSignalElement(unit.imei, sensors[s], 'pressure');
      }
      unitStatusDiagramDiv.appendChild(sensorNoSignalDiv);
    }
  }
}

function displayUnitPressureStatusExpanded(unitStatusDiagramDiv, unit, sensors) {

  sensors.sort(function (s1, s2) {
    if (parseFloat(s1.currentPressure) > parseFloat(s2.currentPressure)) return 1;
    if (parseFloat(s1.currentPressure) < parseFloat(s2.currentPressure)) return -1;
    return 0;
  });

  for (let s = 0; s < sensors.length; s++) {
    let sensorStatusDiv = createSensorPressureElement(unit.imei, sensors[s]);

    unitStatusDiagramDiv.appendChild(sensorStatusDiv);
  }
}

function displayUnitTemperatureStatus(unitStatusDiagramDiv, unit) {

  const sensors = [
    ...unit.wheelSensors,
    ...(unit.spareSensors ? unit.spareSensors : []),
    ...(unit.unpairedSensors ? unit.unpairedSensors : [])
  ];
  sensors.sort(function (s1, s2) {
    if (parseFloat(s1.currentTemperature) < parseFloat(s2.currentTemperature)) return 1;
    if (parseFloat(s1.currentTemperature) > parseFloat(s2.currentTemperature)) return -1;
    return 0;
  });

  for (let s = 0; s < sensors.length; s++) {
    if (sensors[s].signal) {
      let sensorStatusDiv = createSensorTemperatureElement(unit.imei, sensors[s]);
      if (sensors[s]?.unpaired) {
        sensorStatusDiv = createUnpairedSensorTemperatureElement(unit.imei, sensors[s]);
      }
      unitStatusDiagramDiv.appendChild(sensorStatusDiv);
    }
  }

  for (let s = 0; s < sensors.length; s++) {
    if (!sensors[s].signal) {
      let sensorNoSignalDiv = createSensorNoSignalElement(unit.imei, sensors[s], 'temperature');
      if (sensors[s]?.unpaired) {
        sensorNoSignalDiv = createUnpairedSensorNoSignalElement(unit.imei, sensors[s], 'temperature');
      }
      unitStatusDiagramDiv.appendChild(sensorNoSignalDiv);
    }
  }

}

function displayUnitVoltageStatus(unitStatusDiagramDiv, unit) {

  const sensors = [
    ...unit.wheelSensors,
    ...(unit.spareSensors ? unit.spareSensors : []),
    ...(unit.unpairedSensors ? unit.unpairedSensors : [])
  ];

  sensors.sort(function (s1, s2) {
    if (parseFloat(s1.currentVoltage) > parseFloat(s2.currentVoltage)) return 1;
    if (parseFloat(s1.currentVoltage) < parseFloat(s2.currentVoltage)) return -1;
    return 0;
  });

  for (let s = 0; s < sensors.length; s++) {
    if (sensors[s].signal) {
      let sensorStatusDiv = createSensorVoltageElement(unit.imei, sensors[s]);
      if (sensors[s]?.unpaired) {
        sensorStatusDiv = createUnpairedSensorVoltageElement(unit.imei, sensors[s]);
      }
      unitStatusDiagramDiv.appendChild(sensorStatusDiv);
    }
  }

  for (let s = 0; s < sensors.length; s++) {
    if (!sensors[s].signal) {
      let sensorNoSignalDiv = createSensorNoSignalElement(unit.imei, sensors[s], 'voltage');
      if (sensors[s]?.unpaired) {
        sensorNoSignalDiv = createUnpairedSensorNoSignalElement(unit.imei, sensors[s], 'voltage');
      }
      unitStatusDiagramDiv.appendChild(sensorNoSignalDiv);
    }
  }
}

function createUnpairedSensorNoSignalElement(imei, sensor, metric) {
  const sensorNoSignalDiv = document.createElement('div');
  sensorNoSignalDiv.id = `u${imei}${metric}${sensor.sensorId}`;
  let sensorvaluesdivclasses = ['sensorvaluesstatus', 'unpaired'];
  sensorNoSignalDiv.classList.add(...sensorvaluesdivclasses);
  sensorNoSignalDiv.innerText = "S";
  return sensorNoSignalDiv;
}

function createSensorNoSignalElement(imei, sensor, metric) {

  const sensorNoSignalDiv = document.createElement('div');
  sensorNoSignalDiv.id = `u${imei}${metric}${sensor.sensorId}`;
  let sensorvaluesdivclasses = ['sensorvaluesstatus', 'blue'];
  sensorNoSignalDiv.classList.add(...sensorvaluesdivclasses);
  sensorNoSignalDiv.innerText = "S";
  return sensorNoSignalDiv;
}

function createUnpairedSensorPressureElement(imei, sensor) {

  let sensorPressureDiv = document.createElement('div');
  sensorPressureDiv.id = `u${imei}pressure${sensor.sensorId}`;
  let sensorvaluesdivclasses = ['sensorvaluesstatus', 'unpaired'];
  let pressure = parseFloat(sensor.currentPressure).toFixed(1);
  sensorPressureDiv.classList.add(...sensorvaluesdivclasses);
  sensorPressureDiv.innerText = pressure;
  return sensorPressureDiv;
}

function createSensorPressureElement(imei, sensor) {

  let sensorPressureDiv = document.createElement('div');
  sensorPressureDiv.id = `u${imei}pressure${sensor.sensorId}`;
  let sensorvaluesdivclasses = ['sensorvaluesstatus', sensor.pressureLabelColour];
  let pressure = parseFloat(sensor.currentPressure).toFixed(1);
  sensorPressureDiv.classList.add(...sensorvaluesdivclasses);
  sensorPressureDiv.innerText = pressure;
  return sensorPressureDiv;
}

function createUnpairedSensorTemperatureElement(imei, sensor) {

  let sensorTemperatureDiv = document.createElement('div');
  sensorTemperatureDiv.id = `u${imei}temperature${sensor.sensorId}`;
  let sensorvaluesdivclasses = [];
  let temperature = parseInt(sensor.currentTemperature);

  sensorvaluesdivclasses = ['sensorvaluesstatus', 'unpaired'];

  sensorTemperatureDiv.classList.add(...sensorvaluesdivclasses);
  sensorTemperatureDiv.innerText = temperature;
  return sensorTemperatureDiv;
}

function createSensorTemperatureElement(imei, sensor) {

  let sensorTemperatureDiv = document.createElement('div');
  sensorTemperatureDiv.id = `u${imei}temperature${sensor.sensorId}`;
  let sensorvaluesdivclasses = [];
  let temperature = parseInt(sensor.currentTemperature);
  if (sensor.sensorType === 'tyre-nosignal') {
    sensorvaluesdivclasses = ['sensorvaluesstatus', 'blue'];
    temperature = "S";
  }
  else
    sensorvaluesdivclasses = ['sensorvaluesstatus', sensor.temperatureLabelColour];

  sensorTemperatureDiv.classList.add(...sensorvaluesdivclasses);
  sensorTemperatureDiv.innerText = temperature;
  return sensorTemperatureDiv;
}

function createUnpairedSensorVoltageElement(imei, sensor) {

  let sensorVoltageDiv = document.createElement('div');
  sensorVoltageDiv.id = `u${imei}voltage${sensor.sensorId}`;
  let sensorvaluesdivclasses = [];
  let voltage = parseFloat(sensor.currentVoltage).toFixed(1);

  sensorvaluesdivclasses = ['sensorvaluesstatus', 'unpaired'];

  sensorVoltageDiv.classList.add(...sensorvaluesdivclasses);
  sensorVoltageDiv.innerText = voltage;
  return sensorVoltageDiv;
}

function createSensorVoltageElement(imei, sensor) {

  let sensorVoltageDiv = document.createElement('div');
  sensorVoltageDiv.id = `u${imei}voltage${sensor.sensorId}`;
  let sensorvaluesdivclasses = [];
  let voltage = parseFloat(sensor.currentVoltage).toFixed(1);
  if (sensor.sensorType === 'tyre-nosignal') {
    sensorvaluesdivclasses = ['sensorvaluesstatus', 'blue'];
    voltage = "S";
  }
  else
    sensorvaluesdivclasses = ['sensorvaluesstatus', sensor.voltageLabelColour];

  sensorVoltageDiv.classList.add(...sensorvaluesdivclasses);
  sensorVoltageDiv.innerText = voltage;
  return sensorVoltageDiv;
}

